<template>
  
    <div class="reset">

      <transition name="up_down">
        <div class="success" v-if="sucess" @click="router.push('/login');">
          <p>Your Password has been reset <br/><b>Successfully</b><span>{{countdown}}</span></p>
        </div>
      </transition>

      <div class="left_side" :style="onload ? 'left: 70px; opacity: .7;' : null">

        <form @submit.prevent="signInClicked" class="form">
          <h2 @click="countDownTimer()">Enter your new password</h2>
          <p>Your new password must be different than previous passwords. Your password must include 8 or more characters, a special character, a number, and a case change.</p>

          <p class="err_message" v-if="err_pass" v-text="errMsg"></p>
          
          <label>
            <div class="caps_caution" v-if="caps">Caps lock is on</div>

            <input :type="revealOne ? 'text' : 'password'" :class="{ 'err_pass': err_pass }" @keypress="err_pass = false" placeholder="Enter new password" v-model="newPasswordOne"
            @paste="onPaste" @focus="complexity.focus = 1" @blur="complexity.focus = 0">
            <span class="eye" @click="revealOne = !revealOne">
              <span v-if="revealOne"></span>
            </span>
				    <stages class="stages" :complexity="complexity"></stages>
          </label>
          
          <label class="confirm_pass">
            <input :type="revealTwo ? 'text' : 'password'" :class="{ 'err_pass': err_pass }" @keypress="err_pass = false" placeholder="Confirm new password" v-model="newPasswordTwo" @paste="onPaste"
            :disabled="trues != 4">
            <span class="eye" @click="revealTwo = !revealTwo">
              <span v-if="revealTwo"></span>
            </span>
          </label>

          <div class="button_group">
            <button class="back_to_reset" @click.stop="router.push('/login')">Back to sign in</button>
            <button v-if="trues != 4 || newPasswordOne !== newPasswordTwo" class="button disabled submit_reset_disabled" >Reset</button>
            <button v-else @click="newPasswordEntered()" style="text-transform: uppercase;">Reset</button>
          </div>
        </form>

      </div>

      <div class="right_side" :style="onload ? 'right: 70px; opacity: .7;' : null">
        <div class="top"></div>
        <div class="bottom"></div>
      </div>
    </div>
  
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { submitNewPassword } from "supertokens-web-js/recipe/emailpassword";
import stages from '../components/password/password.vue';
import { useRouter } from 'vue-router';
const router = useRouter();

let complexity = ref({
  'focus':0,
  'amount':false,
  'case':false,
  'number':false,
  'special':false
});
let onload = ref(true);
let err_pass = ref(false);
let newPasswordOne = ref('');
let newPasswordTwo = ref('');
let caps = ref(false);
let errMsg = ref('Wrong Password');
let revealOne = ref(false);
let revealTwo = ref(false);
let trues = ref(0);
let sucess = ref(false);
let countdown = ref(3);

function countDownTimer () {
  if (countdown.value > 0) {
    setTimeout(() => {
      countdown.value -= 1
      countDownTimer();
    }, 1000)
  } else if (countdown.value == 0) {
    router.push('/login');
  }
}

document.addEventListener('keyup', (e) => {
  if (e.getModifierState('CapsLock')) {
    caps.value = true;
  } else {
    caps.value = false;
  }
});
function onPaste(e) {
	e.preventDefault();
	let pastedText = (e.clipboardData || window.clipboardData).getData('text');
	pastedText = pastedText.split(' ').join('');
	e.clipboardData.setData('text/plain', pastedText);
	document.execCommand("insertHTML", false, pastedText);
};
function watchPass() {
	let hasNumber = /\d/;
	let uppercase = /[A-Z]/;
	let character = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	if (newPasswordOne.value.length >= 8 ) {
		complexity.value.amount = true;
	} else {
		complexity.value.amount = false;
  }
  if (hasNumber.test(newPasswordOne.value)) {
		complexity.value.number = true;
	} else {
		complexity.value.number = false;
  }
  if (uppercase.test(newPasswordOne.value)) {
		complexity.value.case = true;
	} else {
		complexity.value.case = false;
  }
  if (character.test(newPasswordOne.value)) {
		complexity.value.special = true;
	} else {
		complexity.value.special = false;
  }
	trues.value = Object.values(complexity.value).reduce((a, item) => a + (item === true ? 1 : 0), 0);
};

watch(newPasswordOne, () =>
	watchPass(), {
	immediate: true
});

async function newPasswordEntered() {
  // console.log(newPassword.value,'newPassword')
  if (complexity.value <= 1) {
    err_pass.value = true;
    errMsg.value = 'Password is too weak'
  } else if (newPasswordOne.value !== newPasswordTwo.value) {
    err_pass.value = true;
    errMsg.value = "Passwords don't match"
  } else { 
    try {
      let response = await submitNewPassword({
        formFields: [{
          id: "password",
          value: newPasswordOne.value
        }]
      });
      if (response.status === "FIELD_ERROR") {
        response.formFields.forEach(formField => {
          if (formField.id === "password") {
            // New password did not meet password criteria on the backend.
            err_pass.value = true
            errMsg.value = formField.error
          }
        })
      } else if (response.status === "RESET_PASSWORD_INVALID_TOKEN_ERROR") {
        errMsg.value = "Password reset failed. Please try again";
      } else {
        countDownTimer();
        sucess.value = true;
        // errMsg.value = "Password reset successful!";
      }
    } catch (err) {
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        console.log("dude! " + err.message);
      } else {
        console.log("Oops! Something went wrong.");
      }
    }
  }
}

onMounted(() => {
  setTimeout(() => onload.value = false, 10);
});    
</script>

<style lang="scss" scoped>
.success{
  background-color: #e6ece9;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 1;
  display: flex;
  p{
    margin: 8px auto;
    display: inline-block;
    padding-right: 60px;
    position: relative;
    span{
      position: absolute;
      display: flex;
      height: 50px;
      width: 50px;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      align-items: center;
      background-image: url(../../public/img/spinner.svg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
}
.reset {
  background-color: #f8f8f8;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .left_side, .right_side {
    transition: all 0.3s ease;
  }
  .left_side {
    position: absolute;
    left: 0;
    width: 50%;
    height: 100%;
    background-color: #f2f2f2;
    .form {
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -220px;
      width: 400px;
      text-align: center;
      background-image: url(../../public/img/bopus/bopus.svg);
      background-size: 200px;
      background-position: center top;
      background-repeat: no-repeat;
      padding-top: 100px;
      transform: translate(-50%, -100px);
      .button_group{
        display: flex;
        justify-content: space-between;
        margin-top: 46px;
        .back_to_reset{
          margin-right: 16px;
          background-color: transparent;
          color: #787878;
          border: 1px solid #787878;
          cursor: pointer;
        }
        .back_to_reset:hover{
          color: #006C3E;
          border: 1px solid #006C3E;
        }
      }
      .err_login, .err_pass {
        border: 1px solid #CD180A;
      }
      .err_message {
        margin: 0;
        font-size: 0.82rem;
        text-align: left;
        line-height: 16px;
        margin-top: -10px;
        margin-bottom: 10px;
        color: #CD180A;
        text-indent: 0px;
      }
      label {
        position: relative;
        margin-top: 5px;
        margin-bottom: 16px;
        display: block;
        left: 0;
        .caps_caution{
          position: absolute;
          color: #1467d0;
          font-size: .75rem;
          line-height: .82rem;
          top: -1rem;
          font-weight: 500;
          right: 0;
        }
        .caps_caution::before{
          display: inline-block;
          content: 'i';
          color: #fff;
          background-color: #1467d0;
          height: .8rem;
          width: .8rem;
          line-height: .9rem;
          font-size: .6rem;
          border-radius: 50%;
          font-style: italic;
          position: absolute;
          left: -.9rem;
          top: -1px;
          text-align: center;
          text-indent: -2px;
        }
      }
      .confirm_pass{
        margin-top: 32px;
      }
      .eye {
        display: inline-block;
        height: 40px;
        width: 40px;
        position: absolute;
        right: 5px;
        top: 10px;
        background-image: url(../../public/img/password.png);
        background-position: center;
        background-repeat: no-repeat;
				cursor: pointer;
        span {
          display: inline-block;
          height: 27px;
          width: 2px;
          background-color: #787878;
          transform: rotate(60deg);
          position: relative;
          top: 7px;
          right: 0px;
        }
      }
      >p {
        color: #787878;
        font-size: 1rem;
        line-height: 1.2rem;
        margin-bottom: 40px;
      }
      h2 {
        font-size: 1.53rem;
        line-height: 1.8rem;
        height: 40px;
        margin-bottom: 16px;
      }
      input, button {
        max-width: 400px;
        box-sizing: border-box;
        border: none;
        outline: none;
        border-radius: 8px;
        transition: all .3s;
      }
      button:hover {
        background-color: #f2f8f5;
        color: #006C3E;
        border: 1px solid #006C3E;
      }
      input {
        width: 100%;
        border: 1px solid #fff;
        box-sizing: border-box;
        height: 60px;
        line-height: 60px;
        box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.02);
        text-indent: 16px;
        color: #787878;
        font-size: 1rem;
        position: relative;
      }
      input:disabled {
        border: 1px solid #ececec;
        background-color: #ececec;
      }
      input::placeholder {
        color: #787878;
        font-size: 1rem;
        font-family: 'Inter', sans-serif;
      }
      button {
        width: 100%;
        height: 60px;
        background-color: #006C3E;
        font-weight: 500;
        font-size: 1rem;
        color: #fff;
        cursor: pointer;
      }
      .submit_reset_disabled{
        border-color: #bcbcbc;
        color: #fff;
        background-color: #bcbcbc;
        border: none;
        cursor: default;
      }
      .submit_reset_disabled:hover {
        border-color: #bcbcbc;
        color: #fff;
        background-color: #bcbcbc;
        border: none;
      }
    }
  }
  .right_side {
    position: absolute;
    width: 50%;
    height: 100%;
    right: 0;
    background-color: #006C3E;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(../../public/img/w7login.png);
    .top {
      position: absolute;
      top: 0;
      width: 100%;
      height: 40%;
      transform: rotate(180deg);
    }
    .bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40%;
    }
    .top, .bottom {
      background-image: url(../../public/img/vectors.png);
      background-position: bottom;
      background-repeat: repeat-x;
    }
  }
}

@media screen and (max-width: 1024px) and (min-width: 600px) and (max-height: 1366px) and (min-height: 961px) and (orientation: portrait) {
  .reset {
    .left_side {
      background-image: url(../../public/img/vectors2.png);
      background-position: top;
      background-repeat: repeat-x;
      width: 100%;
      background-size: 540px;
      .form {
        background-image: url(../../public/img/bopus/bopus.svg);
        background-size: 180px;
        background-position: center top;
        background-repeat: no-repeat;
        padding-top: 100px;
        top: 45%;
        left: 50%;
        transform: translate(-50%,-10%);
      }
    }
    .right_side {
      display: none;
    }
  }
}

@media screen and (max-width: 599px) and (orientation: portrait) {
  .reset {
    .left_side {
      background-image: url(../../public/img/vectors2.png);
      background-position: center -60px;
      background-repeat: repeat-x;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      .form {
        background-image: url(../../public/img/bopus/bopus.svg);
        background-size: 120px;
        background-position: center top;
        background-repeat: no-repeat;
        padding-top: 60px;
        width: inherit;
        box-sizing: border-box;
        position: relative;
        margin-top: 200px;
        text-align: center;
        top: auto;
        left: auto;
        margin-left: auto;
        transform: translateX(0%);

        > p {
          color: #787878;
          font-size: 1rem;
          line-height: 1.2rem;
          margin-bottom: 25px;
          margin-top: 8px;
        }

        h2 {
          font-size: 1.53rem;
          line-height: 1.8rem;
          height: 32px;
          margin-bottom: 18px;
        }
      }
    }
    .right_side {
      display: none;
    }
  }
}
@media screen and (max-height: 500px) and (orientation: landscape) {
  .reset {
    .left_side {
      width: 100%;
    }
    .right_side {
      display: none;
    }
  }
}

.slide-err-enter-active,
.slide-err-leave-active {
  transition: all 0.3s ease-out;
}

.slide-err-enter-from,
.slide-err-leave-to {
  margin-top: -30px;
}

.up_down-enter-active,
.up_down-leave-active{
  transition: all .2s ease-in-out;
}
.up_down-enter-from,
.up_down-leave-to{
  transform: translateY(-100%);
}
</style>
